import React from 'react';

import Coins from '../../../../assets/media/tournament/coins.png';
import Coin from '../../../../assets/media/tournament/coin.png';
import Star from '../../../../assets/media/tournament/star.svg';

const stars = Array.from(new Array(13)).map((_, i) => i + 1);

interface TournamentModalImagesProps {

}

export const TournamentModalImages: React.FC<TournamentModalImagesProps> = () => {
  return (
    <>
      <div className="icon-block icon-right">
        <img src={Coins} alt="Coins" />
      </div>
      <div className="icon-block icon-left">
        <img src={Coin} alt="Coin" />
      </div>
      {
        stars.map((index) => (
          <div
            key={index}
            className={`star-block star${index}`}
          >
            <img src={Star} alt="Star" />
          </div>
        ))
      }
    </>
  );
};
